import {
    GET_FamilyMem,
    ADD_FamilyMem,
    TOGGLE_FamilyMem,
    RESET_FamilyMem,
    UPDATE_FamilyMem
  } from "../actionTypes";

const elderFamilyMembersReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_FamilyMem:
      return action.payload;

    case ADD_FamilyMem:
      return action.payload;

    case UPDATE_FamilyMem:
      return state.map(item =>
        item.id === action.payload.id ? action.payload : item
      );

    case TOGGLE_FamilyMem:
      return {
        ...state,
        users: state.users.map(item =>
          item.userId === action.payload.userId ? action.payload : item
        )
      };

    case RESET_FamilyMem:
      return null;

    default:
      return state;
  }
};

export default elderFamilyMembersReducer;
